import React from 'react';
import { useSelector } from 'react-redux';
import Behaviour from 'components/prism/behaviour';
import Rating from 'components/prism/rating';

export const Explore = ({ text, data }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);

    // Group data by area
    const groupedData = React.useMemo(() => {
        if (!data?.length) return {};
        
        return data.reduce((groups, item) => {
            const area = item.area;
            if (!groups[area]) {
                groups[area] = [];
            }
            groups[area].push(item);
            return groups;
        }, {});
    }, [data]);

    return (
        <>
            <h2 className="mb10">{text.explore} 
                <span className="ml10" style={{ fontWeight: 400 }}>
                    {data?.length}
                </span>
            </h2>
            {Object.entries(groupedData).map(([areaName, items]) => (
                <div key={areaName} className="mb30">
                    <h3 className="mb20">{areaName} <Rating level={items[0]?.areaLevel} /></h3>
                    <div className={prismMultiColumn ? 'even-col' : ''}>
                        {items.map(item => (
                            <Behaviour key={`recommended-${item.id}`} padBottom={!prismMultiColumn} item={item} />
                        ))}
                    </div>
                </div>
            ))}
        </>
    );
};

export default Explore;
